import { Box, Grid, Skeleton } from '@mui/material'
import React from 'react'

const WalletSkeleton = () => {
    return (
        <Grid container spacing={2} sx={{ width: '100%', margin: "0", height: "calc(100svh - 140px)" }} >
            <Grid
                xs={12}
                sx={{
                    background: '#fff',
                    height: '45%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingInline: "20px"

                }}
            >
                <Skeleton width={"100%"} height={200} sx={{ transform: "unset" }} />
            </Grid>
            <Box
                display="flex" gap={"10px"} flexWrap="wrap"
                sx={{
                    margin: "auto", marginTop: "10px",
                    flex: 1,
                    paddingInline: "20px",
                    justifyContent: "center",
                    maxHeight: "55%",
                    overflowY: "auto",
                    alignItems: "center"
                }}

            >
                {[...Array(4)].map((_, index) => (
                    <Skeleton key={index} width={"100%"} height={150} sx={{ marginTop: "10px", transform: "unset", flex: '1 1 calc(50% - 16px)' }} />
                ))}
            </Box>
        </Grid>
    )
}

export default WalletSkeleton